import CollapsibleInfoBarList from "./CollapsibleInfoBarList";

export default CollapsibleInfoBarList;
